import { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { SortOrder } from 'primereact/api';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { Nullable } from 'primereact/ts-helpers';
import findNotificacaoFatura from '../../service/findNotificacaoFatura';
import getTipoIntervaloNotificacao from '../../service/getTipoIntervaloNotificacao';
import patchNotificacaoFaturaService from '../../service/patchNotificacaoFatura';

export default function NotificacaoFaturaList({onEdit}:{onEdit:(notificacaoFatura:any)=>void}) {
  const { t } = useTranslation();
  const [notificacoesFatura, setNotificacoesFatura] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const [assunto, setAssunto] = useState<Nullable<String | null>>(null);
  const [tipoIntervalo, setTipoIntervalo] = useState<Nullable<String | null>>(null);
  const [tiposIntervalo, setTiposIntervalo] = useState<any>([]);
  const toast = useRef<Toast>(null);

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    assunto: assunto,
    tipoIntervalo: tipoIntervalo,
    sortField: 'assunto',
    sortOrder: SortOrder.DESC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      assunto: assunto,
      tipoIntervalo: tipoIntervalo,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event:any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      assunto: assunto,
      tipoIntervalo: tipoIntervalo,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const changeAssunto = (value:Nullable<String>) => {
    const novoAssunto = value ? value : null;
    setAssunto(novoAssunto);
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      assunto: novoAssunto,
      tipoIntervalo: tipoIntervalo,
      sortField: 'assunto',
      sortOrder: SortOrder.ASC
    });
  }

  const changeTipoIntervalo = (value:Nullable<String>) => {
    const novoTipoIntervalo = value ? value : null;
    setTipoIntervalo(novoTipoIntervalo);
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      assunto: assunto,
      tipoIntervalo: novoTipoIntervalo,
      sortField: 'assunto',
      sortOrder: SortOrder.ASC
    });
  }

  const loadLazyData = () => {
    findNotificacaoFatura(lazyState).then(data => {setTotalRecords(data.total);setNotificacoesFatura(data.notificacoesFatura)}).catch(() => {setTotalRecords(0);setNotificacoesFatura(undefined)});
  }

  const startContent = (
    <div className="filtros">
      <div className="filtros-grid">
        <div className="filtros-item">
          <label htmlFor="assunto" className="font-bold">{t('assunto')}</label>
          <InputText id="assunto" onBlur={(e)=>changeAssunto(e.target.value)}></InputText>
        </div>
        <div className="filtros-item">
          <label htmlFor="tipoIntervalo" className="font-bold">{t('tipoIntervalo')}</label>
          <Dropdown inputId="tipoIntervalo" value={tipoIntervalo} onChange={(e) => changeTipoIntervalo(e.value)} options={tiposIntervalo} optionLabel="label" optionValue="value" placeholder="Selecione Tipo de Intervalo" showClear filter />
        </div>
      </div>
    </div>
  );

  const editBodyTemplate = (notificacaoFatura:any) => {
    return <Button icon="pi pi-pencil" onClick={() => onEdit(notificacaoFatura)} style={{background:'transparent', color:'gray', border: 'none'}} />;
  };

  const tipoIntervaloBodyTemplate = (notificacaoFatura:any) => {
    return notificacaoFatura.tipoIntervaloLabel || notificacaoFatura.tipoIntervalo;
  };

  const canalLabels:any = { EMAIL: 'E-mail', WHATSAPP: 'WhatsApp', AMBOS: 'E-mail e WhatsApp' };
  const canalBodyTemplate = (notificacaoFatura:any) => {
    return canalLabels[notificacaoFatura.canalNotificacao] || notificacaoFatura.canalNotificacao || 'E-mail';
  };

  const repeteBodyTemplate = (notificacaoFatura:any) => {
    return <Tag value={notificacaoFatura.repete ? 'Sim' : 'Não'} severity={notificacaoFatura.repete ? 'success' : 'danger'} />;
  };

  const alterarInativo = (notificacaoFatura:any, inativo:boolean) => {
    patchNotificacaoFaturaService(notificacaoFatura.id, inativo)
      .then(() => {
        notificacaoFatura.inativo = inativo;
        toast.current?.show({ severity: 'success', summary: 'Sucesso', detail: inativo ? 'Notificação inativada' : 'Notificação ativada', life: 3000 });
        loadLazyData();
      })
      .catch((error:any) => {
        toast.current?.show({ severity: 'error', summary: 'Erro', detail: error?.message || 'Erro ao alterar status da notificação', life: 5000 });
      });
  };

  const inativoBodyTemplate = (notificacaoFatura:any) => {
    return <InputSwitch checked={notificacaoFatura.inativo} onChange={(e) => alterarInativo(notificacaoFatura, e.value)} />;
  };

  useEffect(() => {
    getTipoIntervaloNotificacao().then((data) => setTiposIntervalo(data));
    loadLazyData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[lazyState])

  return (
    <div>
      <Toast ref={toast} />
      <div>
        <Toolbar start={startContent} />
        <br></br>
        <br></br>
        <DataTable value={notificacoesFatura} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros"
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           <Column field="assunto" sortable header={t('assunto')}  />
           <Column field="intervaloDia" sortable header={t('intervaloDia')}  />
           <Column body={tipoIntervaloBodyTemplate} sortField="tipoIntervalo" sortable header={t('tipoIntervalo')}  />
           <Column body={canalBodyTemplate} header={t('canal')}  />
           <Column body={repeteBodyTemplate} header={t('repete')}  />
           <Column body={inativoBodyTemplate} header={t('inativo')}  />
           <Column body={editBodyTemplate} />
        </DataTable>
      </div>
    </div>
  )
}
